export const handleScrollValue = (): 0 | 50 | 100 => {
    const h = document.documentElement;
    const b = document.body;
    const scrollTop = 'scrollTop';
    const scrollHeight = 'scrollHeight';
    const scrollPercentRounded = Math.round(
        ((h[scrollTop] || b[scrollTop]) / ((h[scrollHeight] || b[scrollHeight]) - h.clientHeight)) *
            100
    );

    if ((h[scrollHeight] || b[scrollHeight]) <= h.clientHeight) {
        return 100;
    } else if (scrollPercentRounded >= 0 && scrollPercentRounded < 50) {
        return 50;
    } else if (scrollPercentRounded >= 50 && scrollPercentRounded <= 100) {
        return 100;
    } else {
        return 0;
    }
};
